"use client";

import { c as _c } from "react/compiler-runtime";
import { TChapterListItem } from "@/types/types";
import { formatDuration } from "@/utils/formatters";
import { cn } from "@/utils/helpers";
import { Circle, CircleCheck, Lock } from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
type ChaptersListItemProps = {
  chapter: TChapterListItem & {
    isCompleted: boolean;
  };
  hasUserEnrolled: boolean;
};
export default function ChaptersListItem(t0) {
  const $ = _c(21);
  const {
    chapter,
    hasUserEnrolled
  } = t0;
  const pathname = usePathname();
  const segments = pathname.split("/");
  const chapterSlug = segments[segments.findIndex(_temp) + 1];
  const chapterUrl = `${pathname?.split("/").slice(0, -1).join("/")}/${chapter.slug}`;
  const t1 = chapter.id;
  const t2 = chapter.slug === chapterSlug && "bg-courseAccent text-darkGray hover:text-foreground";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("flex items-center gap-2 rounded-xl p-3 text-sm transition hover:bg-muted", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== chapter.isCompleted || $[3] !== chapter.isFree || $[4] !== hasUserEnrolled) {
    t4 = <div className="size-[14px]">{hasUserEnrolled ? chapter.isCompleted ? <CircleCheck size={14} /> : <Circle size={14} /> : chapter.isFree ? <Circle size={14} /> : <Lock size={14} />}</div>;
    $[2] = chapter.isCompleted;
    $[3] = chapter.isFree;
    $[4] = hasUserEnrolled;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== chapter.title) {
    t5 = <p className="text-ellipsis pl-2">{chapter.title}</p>;
    $[6] = chapter.title;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = chapter.chapterVideo?.duration || 0;
  let t7;
  if ($[8] !== t6) {
    t7 = formatDuration(t6);
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = <span className="ml-auto text-xs">{t7}</span>;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== chapterUrl || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t8) {
    t9 = <Link href={chapterUrl} className={t3}>{t4}{t5}{t8}</Link>;
    $[12] = chapterUrl;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== chapter.id || $[19] !== t9) {
    t10 = <li key={t1}>{t9}</li>;
    $[18] = chapter.id;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(segment) {
  return segment === "chapter";
}